import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '../ResponsiveImage/index.js';
import {
  StyledSplitPanelBody,
  IconContainer,
  Header,
  Body,
  SocialMediaIcons,
} from './styles.js';

export const SplitPanelBody = ({ heading, icon, body, socialMediaIcons }) => {
  return (
    <StyledSplitPanelBody>
      {icon && (
        <IconContainer>
          <ResponsiveImage
            alt={icon.alt}
            src={icon.src}
            width={icon.width}
            height={icon.height}
          />
        </IconContainer>
      )}
      {heading && <Header>{heading}</Header>}
      <Body>{body}</Body>
      {socialMediaIcons && (
        <SocialMediaIcons>
          {socialMediaIcons.map((SMIcon, i) => (
            <a key={i} href={SMIcon.url} rel="noreferrer" target="_blank">
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img alt={SMIcon.alt} src={SMIcon.src} />
            </a>
          ))}
        </SocialMediaIcons>
      )}
    </StyledSplitPanelBody>
  );
};

SplitPanelBody.displayName = 'SplitPanelBody';

SplitPanelBody.propTypes = {
  icon: PropTypes.shape({
    alt: PropTypes.string.isRequired,
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
  }),
  heading: PropTypes.string,
  body: PropTypes.node,
  socialMediaIcons: PropTypes.arrayOf(
    PropTypes.shape({
      alt: PropTypes.string.isRequired,
      src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
};
